<template>
  <section v-if="variants.v1 === variant">
    <div style="position: relative">
      <library-container :key="renderKey" class="tw-relative tw-z-10 tw-py-24">
        <div class="tw-mb-8">
          <library-title tag="h3" :text="vars.titleText"></library-title>
        </div>
        <div
          v-for="(item, index) in items"
          :key="`client-testimonial-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-8 md:tw-gap-x-16 md:tw-gap-y-0"
          :style="visibleIndex === index ? 'display: grid;' : 'display: none;'"
        >
          <div class="pxp-services-h-container tw-col-span-12 md:tw-col-span-7">
            <template v-if="vars.isPopupBool">
              <div
                class="pxp-cover pxp-animate-in tw-relative tw-z-10 tw-h-[496px] tw-w-full tw-rounded"
                :style="`background-image: url(${item.image}); `"
              >
                <div
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                  @click="togglePopup(true)"
                >
                  <a class="pxp-video-section-trigger tw-cursor-pointer">
                    <span class="fa fa-play"></span>
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <iframe
                class="tw-h-[496px] tw-w-full tw-rounded"
                :src="item.video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </template>
          </div>
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-end tw-gap-y-4 md:tw-col-span-5">
            <div class="tw-flex tw-gap-x-3">
              <span
                v-for="i in item.star_count"
                :key="`star-${i}`"
                class="fa fa-star tw-text-2xl"
                :style="`color: var(--camel)`"
              ></span>
            </div>
            <library-title tag="h4" :text="item.title" style="font-weight: 900"></library-title>
            <library-text :text="item.description"> </library-text>
            <library-text :text="item.author" style="color: #808080; font-weight: bold"></library-text>
            <div class="tw-mt-8 tw-pl-6" @click="goNextOne()">
              <div
                class="pxp-areas-carousel-right-arrow pxp-animate"
                style="opacity: 1 !important; position: static !important"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32.414" height="20.828" viewBox="0 0 32.414 20.828">
                  <g id="Symbol_1_1" data-name="Symbol 1 – 1" transform="translate(-1847.5 -1589.086)">
                    <line
                      id="Line_2"
                      data-name="Line 2"
                      x2="30"
                      transform="translate(1848.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_3"
                      data-name="Line 3"
                      x2="9"
                      y2="9"
                      transform="translate(1869.5 1590.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                    <line
                      id="Line_4"
                      data-name="Line 4"
                      y1="9"
                      x2="9"
                      transform="translate(1869.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    ></line>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </library-container>
      <div
        class="tw-absolute tw-top-0 tw-z-0 tw-mt-10 tw-h-[260px] tw-w-full md:tw-bottom-0 md:tw-left-0 md:tw-top-[unset] md:tw-h-[406px] md:tw-w-[330px] lg:tw-mt-0 lg:tw-w-[530px]"
        style="background-color: var(--purple)"
      ></div>
    </div>
  </section>

  <section v-if="variants.v2 === variant">
    <div style="position: relative">
      <library-container :key="renderKey" class="tw-relative tw-z-10 tw-py-24">
        <div class="tw-mb-8">
          <h3>{{ vars.titleText }}</h3>
        </div>

        <div
          v-for="(item, index) in items"
          :key="`client-testimonial-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-8 md:tw-gap-x-16 md:tw-gap-y-0"
          :style="visibleIndex === index ? 'display: grid;' : 'display: none;'"
        >
          <!-- Kapak resmi varsa göster, yoksa video iframe -->
          <div class="pxp-services-h-container tw-col-span-12 md:tw-col-span-7">
            <template v-if="item.image">
              <div
                class="pxp-cover pxp-animate-in overflow-hidden tw-relative tw-z-10 tw-h-[496px] tw-w-full tw-rounded"
                :style="`
                background-image: url(${item.image});
                background-size: cover;
                background-position: center;
              `"
              >
                <div
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                  @click="
                    togglePopup(true);
                    currentVideoUrl = item.video;
                  "
                >
                  <!-- Yeni SVG play butonu -->
                  <svg width="58" height="54" viewBox="0 0 58 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M29.3504 0.333008C23.6892 0.333008 18.155 1.89698 13.4479 4.82715C8.7407 7.75732 5.07191 11.9221 2.90544 16.7948C0.738965 21.6675 0.172117 27.0293 1.27657 32.2021C2.38103 37.3749 5.10719 42.1265 9.11031 45.8559C13.1134 49.5853 18.2137 52.125 23.7662 53.154C29.3187 54.1829 35.074 53.6548 40.3043 51.6365C45.5346 49.6181 50.0051 46.2002 53.1503 41.8149C56.2955 37.4296 57.9743 32.2738 57.9743 26.9997C57.9743 23.4978 57.2339 20.0301 55.7954 16.7948C54.3569 13.5594 52.2485 10.6197 49.5905 8.14349C46.9326 5.66726 43.7771 3.70301 40.3043 2.36289C36.8315 1.02276 33.1094 0.333008 29.3504 0.333008ZM23.6257 38.9997V14.9997L40.8 26.9997L23.6257 38.9997Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </template>
            <template v-else>
              <iframe
                class="tw-h-[496px] tw-w-full tw-rounded"
                :src="item.video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </template>
          </div>

          <!-- Metin ve yıldızlar -->
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-end tw-gap-y-4 md:tw-col-span-5">
            <div class="tw-flex tw-gap-x-3">
              <span
                v-for="i in item.star_count"
                :key="`star-${i}`"
                class="fa fa-star tw-text-2xl"
                style="color: #90c73d"
              ></span>
            </div>
            <h5 style="color: #fff !important">{{ item.title }}</h5>
            <p style="color: #fff !important">{{ item.description }}</p>
            <library-text :text="item.author" style="color: #fff; font-weight: bold" />
            <div class="tw-mt-8 tw-pl-6" @click="goNextOne()">
              <div
                class="pxp-areas-carousel-right-arrow pxp-animate"
                style="opacity: 1 !important; position: static !important"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32.414" height="20.828" viewBox="0 0 32.414 20.828">
                  <g transform="translate(-1847.5 -1589.086)">
                    <line
                      x2="30"
                      transform="translate(1848.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                    <line
                      x2="9"
                      y2="9"
                      transform="translate(1869.5 1590.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                    <line
                      y1="9"
                      x2="9"
                      transform="translate(1869.5 1599.5)"
                      fill="none"
                      stroke="#333"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </library-container>

      <!-- Tam genişlikte mor arka plan -->
      <div
        class="tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-z-0 tw-mt-10 tw-h-[260px] md:tw-bottom-0 md:tw-top-[unset] md:tw-h-[506px]"
        style="background-color: #7f338f"
      ></div>

      <!-- Video popup -->
      <library-popups-video-popup v-model:is-visible="isPopupVisible" :video-url="currentVideoUrl" />
    </div>
  </section>

  <library-popups-video-popup
    v-if="vars.isPopupBool"
    v-model:is-visible="isPopupVisible"
    :video-url="visibleTestimonial.video"
  />
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { produceKey } from '~/server/core/helpers';
import { jQuery } from 'public/theme3/js/custom';

export default defineNuxtComponent({
  name: 'Theme3ClientTestimonials',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      isPopupVisible: false,
      visibleIndex: 0,

      renderKey: produceKey(),
    };
  },

  computed: {
    visibleTestimonial() {
      return this.items[this.visibleIndex];
    },

    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    togglePopup(status = false) {
      this.isPopupVisible = status;
    },

    goNextOne() {
      if (this.items.length !== this.visibleIndex + 1) {
        this.visibleIndex += 1;
      } else {
        this.visibleIndex = 0;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },
  },
});
</script>
